<template>
     <div>
         <h1>Foundation</h1>
     </div>
</template>

<script>
export default {
    name: 'Foundation',
    components: {

    },
    data(){
        return {

        }
    },
    methods:{

    }
}
</script>

<style>


</style>